import React from "react";
import PortalModal from "../../Portals";
import { CancelConfirmationContent } from "./ConfirmationModal.styled";

const CancelConfirmation = ({
  getCancelConfirmation,
  getSuccessConfirmation,
  title,
  content,
  cancelConfirmation,
  sccessConfirmation,
}) => {
  return (
    <PortalModal>
      <CancelConfirmationContent>
        <div className="system-alert">{title}</div>
        <div className="text">{content}</div>
        <div className="popUpActionButton">
          <button
            className="cancel"
            onClick={() => {
              getCancelConfirmation();
            }}
          >
            {cancelConfirmation}
          </button>
          <button
            onClick={() => {
              getSuccessConfirmation();
            }}
          >
            {sccessConfirmation}
          </button>
        </div>
      </CancelConfirmationContent>
    </PortalModal>
  );
};
export default CancelConfirmation;
